import { render, staticRenderFns } from "./SolanStudentViewLookbackT.vue?vue&type=template&id=0b057b33&scoped=true&"
import script from "./SolanStudentViewLookbackT.vue?vue&type=script&lang=ts&"
export * from "./SolanStudentViewLookbackT.vue?vue&type=script&lang=ts&"
import style0 from "./SolanStudentViewLookbackT.vue?vue&type=style&index=0&id=0b057b33&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b057b33",
  null
  
)

export default component.exports